import {restoreSupplier} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../supplier-keys";

export function restoreSupplierMutationOptions() {
  return mutationOptions({
    mutationKey: supplierMutationKeys.restoreSupplier,
    mutationFn: (id: string) => restoreSupplier(id),
    onSuccess: async (_data, id, _context, {client}) => {
      client.removeQueries({queryKey: supplierKeys.detail(id)});
      await client.invalidateQueries({queryKey: supplierKeys.lists()});
    },
  });
}
